import React from 'react'
import clsx from 'clsx'

import BaseModal from '../BaseModal2'
import Button from '../../../atoms/Button2'
import { GreyButton } from '../../../organisms/ChatWindowV2/Header/EditParticipantsModal'

import { useBreakpoint } from '../../../../providers/BreakpointProvider'
import useStyles from './styles'

export interface AreYouSureModalProps {
  title: string
  text: string
  onCancel: () => void
  onConfirm: () => void
  cancelText?: string
  confirmText?: string
}

const AreYouSureModal: React.FC<AreYouSureModalProps> = ({
  title,
  text,
  onCancel,
  onConfirm,
  cancelText = 'Cancel',
  confirmText = 'Yes'
}) => {
  const { isMedium, isSmall } = useBreakpoint()

  const classes = useStyles()

  return (
    <BaseModal
      open
      hideTitle
      onClose={onCancel}
      PaperProps2={{
        style: {
          padding: '0',
          border: '1px solid #C6C6C6',
          borderRadius: '4px',
          width: isMedium ? 'calc(100% - 4rem)' : '512px',
          minHeight: isSmall ? '260px' : undefined,
          height: isSmall ? '260px' : undefined,
          maxHeight: isSmall ? '260px' : undefined,
          maxWidth: 'unset'
        }
      }}
      classes={{ close: classes.close, title: null }}
      // TODO: Fix types on BaseModal and remove these useless props
      PaperProps={{}}
      className=''
      variant={null}
      title=''
      titleClass=''
    >
      <div className={classes.root}>
        <div className={classes.title}>{title}</div>

        <div className={classes.text}>{text}</div>

        <div
          className={clsx(
            classes.buttonArea,
            classes.buttonAreaSub,
            isSmall && classes.buttonAreaMobile
          )}
        >
          <Button onClick={onCancel} className={classes.button}>
            {cancelText}
          </Button>

          <GreyButton onClick={onConfirm} className={classes.button}>
            {confirmText}
          </GreyButton>
        </div>
      </div>
    </BaseModal>
  )
}

export default AreYouSureModal
